/* eslint-disable import/no-unused-modules */
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './assets/css/normalize.css';
import 'rsuite/styles/index.less';
import './styles/index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.captureConsoleIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/testing\.api\.maasloop\.com\/api/,
        /^https:\/\/staging\.api\.maasloop\.com\/api/,
        /^https:\/\/api\.maasloop\.com\/api/,
    ],
});

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

reportWebVitals();
